import { create } from 'zustand'
import type { User, UserRole } from '../types/index'
import { getAuthData, clearAuth } from '../utils/auth'

interface AuthState {
  isAuthenticated: boolean
  user: User | null
  
  // Actions
  checkAuth: () => void
  logout: () => void
  hasRole: (roles: UserRole[]) => boolean
}

// 从 cookie 同步认证状态
export const useAuthStore = create<AuthState>()((set, get) => ({
  isAuthenticated: false,
  user: null,

  checkAuth: () => {
    const authData = getAuthData()
    if (authData) {
      // 转换为 User 类型
      const user: User = {
        id: authData.username,
        username: authData.username,
        email: `${authData.username}@example.com`,
        role: mapRole(authData.role),
        status: 'active',
        createdAt: new Date().toISOString().split('T')[0],
      }
      set({ isAuthenticated: true, user })
    } else {
      set({ isAuthenticated: false, user: null })
    }
  },

  logout: () => {
    clearAuth()
    set({ isAuthenticated: false, user: null })
  },

  hasRole: (roles: UserRole[]) => {
    const user = get().user
    return user ? roles.includes(user.role) : false
  },
}))

// 角色映射：将 Cloudflare Worker 的角色映射到本地角色
function mapRole(role: string): UserRole {
  const roleMap: Record<string, UserRole> = {
    'admin': 'admin',
    'pm': 'admin', // PM 也映射为 admin
    'employee': 'annotator', // 员工映射为标注员
    'annotator': 'annotator',
    'reviewer': 'reviewer',
    'query_user': 'query_user',
  }
  return roleMap[role] || 'query_user'
}
